const orderInitialState =  {
  openPopup:false,
  accountNumber:null,
  orderNumber:null,
  autoRefillOrderNumber:null,
  errorMessage:null,
  orderTerms:null,
  arOrderTerms:null,
  orderTermsErrorMessage:null,
  isLoading: false
};

export default orderInitialState;



// WEBPACK FOOTER //
// ./src/store/initialStates/orderInitialState.js